import { useCallback, useState } from 'react';

export const useFocusField = <T>() => {
  const [focus, setFocus] = useState<T>();

  const handleFieldFocus = useCallback(
    (field: T) => () => setFocus((prev) => (prev === field ? undefined : field)),
    [],
  );

  return { focus, handleFieldFocus };
};
